(function () {
  "use strict";

  CopyPasteUrlCtrl.$inject = ['$scope'];
  angular
    .module('trainerWebApp.modals')
    .controller('CopyPasteUrlCtrl', CopyPasteUrlCtrl);

  function CopyPasteUrlCtrl($scope) {
    $scope.$on('openShareUrlRequestedEvent', function (event, params) {
      $scope.modal = {
        shareType: params.type,
        content: params.url
      };
      $scope.show();
    });
  }

})();
